/**
 * Cashier Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var BaseCollection = require('common/base.collection');
    var cashierConfig = require('portlets/cashier/cashier.config');
    var server = require('server');
    var user = require('user');

    module.exports = BaseCollection.extend({

        paymentMethod: null,

        model: null,

        paymentMethodsOrder: null,

        suggestDepositAmounts: false,

        config: null,

        comparator: function(model) {
            if (model.get('ordering')) {
                return model.get('ordering')[this.paymentMethodsOrder];
            }
        },

        initialize: function(models, options) {
            options = options || {};
            this.paymentMethodsOrder = options.paymentMethodsOrder
                || this.paymentMethodsOrder || 'byCasinoConfiguration';
            if (options.suggestDepositAmounts != null) {
                this.suggestDepositAmounts = options.suggestDepositAmounts;
            }

            this.config = options.config || {};
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                var methods = server.send({
                    ID: 33001,
                    description: 'Get Payment Method list.',
                    type: this.paymentMethod,
                    correlationId: this.getCorrelationId(),
                    byplayerhistory: this.paymentMethodsOrder === 'byPlayerHistory',
                    bycountrypopularity: this.paymentMethodsOrder === 'byCountryPopularity',
                    bycasinoconfiguration: this.paymentMethodsOrder === 'byCasinoConfiguration',
                    cancreatenewaccount: true,
                    limits: true,
                    suggestions: this.suggestDepositAmounts,
                    returnaccountfields: true,
                    responses: [33002, 33003]
                });

                var accounts = server.send({
                    ID: 33011,
                    description: 'Get Payment Method Accounts',
                    correlationId: this.getCorrelationId(),
                    hideAccountsWithoutInfo: true,
                    responses: [33012, 33013]
                });

                return $.when(methods, accounts).done(function(mtds, accs) {
                    options.success({
                        methods: mtds,
                        accounts: accs
                    });
                }).fail(options.error);
            }
        },

        parse: function(response) {
            var config = cashierConfig();
            var hideParentPaymentMethods = this.config.hideParentPaymentMethods;
            var methods = response.methods.data.payments ? response.methods.data.payments.method : [];

            var accounts = response.accounts.data.payments
                ? _.indexBy(response.accounts.data.payments.method, 'code')
                : {};
            var skippedSubMethods = ['DotpayBankTransfer'];
            var subMethods = {};

            var getSubMethods = function(method) {
                if (!method.subMethods) {
                    return;
                }

                if (skippedSubMethods.includes(method.code)) {
                    method.subMethods.subMethod = method.subMethods.subMethod.sort(function(a, b) {
                        var aOrder = a.ordering && a.ordering[this.paymentMethodsOrder] || 999;
                        var bOrder = b.ordering && b.ordering[this.paymentMethodsOrder] || 999;

                        return aOrder - bOrder;
                    }.bind(this));

                    return;
                }

                _.each(method.subMethods.subMethod, function(subMethod) {
                    if (!subMethods[method.code]) {
                        subMethods[method.code] = [];
                    }

                    subMethods[method.code].push(
                        _.extend(
                            _.omit(method, 'subMethods'),
                            {
                                code: subMethod.code,
                                methodCode: method.code,
                                name: subMethod.name,
                                ordering: subMethod.ordering,
                                reDirectType: subMethod.reDirectType || method.reDirectType,
                                isSubMethod: true
                            }
                        )
                    );
                });
            }.bind(this);

            var addSubMethods = function(res, method) {
                if (subMethods[method.code]) {
                    _.each(subMethods[method.code], function(subMethod) {
                        res[subMethod.code] = subMethod;
                    });
                }
                res[method.code] = method;
                return res;
            };

            var filterParentMethods = function(method) {
                return !(hideParentPaymentMethods && method.hideParentMethod && subMethods[method.code]);
            };

            methods = _.chain(methods)
                .each(this.addCommonFields.bind(this))
                .each(getSubMethods)
                .reduce(addSubMethods, {})
                .filter(filterParentMethods)
                .each(this.mergeWithAccountFields.bind(this, accounts))
                .each(this.removeHiddenAccounts)
                .each(this.deleteAccountsWithoutSpecParams)
                .value();

            if (this.isVisaCheckoutEnabled()) {
                this.extractVisaCheckoutCCToNewMethod(methods);
            }

            methods = _.chain(methods).filter(this.removeCreditCardMethodsWithNoAccounts.bind(this, config)).value();

            methods = this.afterParse(methods, config, response);

            return methods;
        },

        isVisaCheckoutEnabled: function() {
            var pmCfg = user.get('paymentsConfig');

            return pmCfg && pmCfg.enableVisaCheckout && pmCfg.tokenProvider === 'safecharge';
        },

        extractVisaCheckoutCCToNewMethod: function(methods) {
            var visaCheckoutAccs = methods.reduce(function(memo, method) {
                if (method.account) {
                    method.account = _.filter(method.account, function(item) {
                        if (item.specificParams && item.specificParams.visaCheckout) {
                            item = _.extend(item, {
                                pmCode: method.code,
                                limits: method.limits,
                                suggested: method.suggested,
                                amountRequired: method.amountRequired
                            });

                            memo.account.push(item);

                            return false;
                        }

                        return true;
                    });
                }

                return memo;
            }, {
                name: 'Visa Checkout',
                code: 'VisaCheckout',
                ordering: {
                    byPlayerHistory: 1,
                    byCountryPopularity: 1,
                    byCasinoConfiguration: 1
                },
                account: []
            });

            if (visaCheckoutAccs.account.length) {
                methods.unshift(visaCheckoutAccs);
            }
        },

        deleteAccountsWithoutSpecParams: function(method) {
            if (method.account) {
                method.account = method.account.filter(function(account) {
                    return account.specificParams != null;
                });
            }
        },

        getCorrelationId: function() {
            return this.paymentMethod + '_' + Math.random().toString().replace('0.', '');
        },

        //region Parse methods

        addCommonFields: function(method) {
            method.isSubMethod = false;
        },

        mergeWithAccountFields: function(accounts, method) {
            _.extend(method, accounts[method.code]);
        },

        removeHiddenAccounts: function(method) {
            if (method.account) {
                method.account = method.account.filter(function(account) {
                    return account.view === true;
                });
            }
        },

        removeCreditCardMethodsWithNoAccounts: function(config, method) {
            var methodCfg = config[method.code];

            if (!methodCfg || !methodCfg.creditCard) {
                return true;
            }

            return method.account && method.account.length;
        },

        /**
         * Custom filter to apply to payment methods or accounts
         * @abstract
         * @param {Array} methods - pre-parsed methods
         * @param {Object} config - methods config (from cashier.config)
         * @param {Object} initialResponse
         * @returns {Object}
         */
        afterParse: function(methods, config, initialResponse) { // eslint-disable-line no-unused-vars
            // override in inheritors
            return methods;
        }

        //endregion

    });
});
